module.exports = __webpack_public_path__ + "static/media/ivermedi.c02b75fe.png";